<app-customer-relations-presenter
    [class.dark]="dark"
    [isInToolbar]="isInToolbar"
    [showAddCustomerRelationButton]="showAddCustomerRelationButton"
    [isExpanded]="isExpanded"
    [showSummary]="showSummary"
    [isBusiness]="isBusiness"
    [selectedItem]="selectedItem"
    [installations]="installationItems"
    [formGroup]="formGroup"
    [isSingleInstallationView]="isSingleInstallationView"
    [canToggle]="canToggleDropdown"
    (toggleExpand)="toggleExpand()"
    (addCustomerRelation)="onAddCustomerRelation()"
    (selectInstallation)="onSelectInstallation($event)"
></app-customer-relations-presenter>
